import ContainingFeatureMetadata from './ContainingFeatureMetadata.js';
import { FeatureRecord, FeatureReference } from '../features/index.js';
/**
 * @memberof geodata
 * @namespace availableContainingFeatures
 */
/**
 * @memberof geodata.availableContainingFeatures
 * @param {feature-references.FeatureRecord} feature
 * @return {Promise<FeatureRecord[]>}
 */
function availableContainingFeatures(feature) {
    const geoJSON = feature.toGeoJSON();
    const available = ContainingFeatureMetadata.forFeature(geoJSON)
        .then((metadata) => {
        const containingFeatures = metadata.map((result) => {
            const ref = FeatureReference.fromKey(result.containingFeature);
            const record = new FeatureRecord({
                ref,
                label: result.containingFeatureLabel,
                geometry: result.geometry,
                data: {
                    coverageRatio: result.coverageRatio,
                    featureClass: result.featureClass,
                },
            });
            return record;
        });
        return containingFeatures
            .sort((lhs, rhs) => rhs.data.coverageRatio - lhs.data.coverageRatio);
    });
    return available;
}
/**
 * @memberof geodata.availableContainingFeatures
 * @description Features which contain the provided one with a minimum coverage ratio (0-1)
 * @function limitedByCoverage
 * @param {feature-references.FeatureRecord} feature
 * @param {number} coverageRatioMinimum=0.5
 * @return {Promise<FeatureRecord[]>}
 */
availableContainingFeatures.limitedByCoverage = function (feature, coverageRatioMinimum = 0.5) {
    return availableContainingFeatures(feature)
        .then((containers) => (containers
        .filter((container) => (container.data.coverageRatio >= coverageRatioMinimum))));
};
/**
 * @memberof geodata.availableContainingFeatures
 * @description Features which contain the provided one limited by matching feature class
 * @function limitedByFeatureClass
 * @param {feature-references.FeatureRecord} feature
 * @param {number[]} allowedFeatureClasses - Feature Class IDs
 * @return {Promise<FeatureRecord[]>}
 */
availableContainingFeatures.limitedByFeatureClass = function (feature, allowedFeatureClasses = []) {
    return availableContainingFeatures(feature)
        .then((containers) => (containers
        .filter((container) => (allowedFeatureClasses.includes(container.data.featureClass)))));
};
export default availableContainingFeatures;
